import { Component, AfterViewInit, ViewContainerRef, OnInit, NgZone, ChangeDetectorRef } from '@angular/core';
import { MdButtonToggleGroup } from '@angular/material';
import { Router, ActivatedRoute } from '@angular/router';
import { Title } from '@angular/platform-browser';

import {
  TdLoadingService, TdMediaService, TdDialogService,
  ITdDataTableColumn,
  TdDataTableSortingOrder,
  TdDataTableService,
  ITdDataTableSortChangeEvent,
} from '@covalent/core';

import { Constante } from '../../../models/';
import { ConstantesService, LoginService } from '../../../services/';
import { ConstantesDetalleComponent } from './detalleconstantes/detalleconstantes.component';

@Component({
  selector: 'qs-constantes',
  templateUrl: './constantes.component.html',
  styleUrls: ['./constantes.component.scss'],
  viewProviders: [ConstantesService],
})
export class ConstantesComponent implements AfterViewInit {

  private idPaciente: string;
  private constantesCE: any;
  private constantesCA: any;
  private constantesCG: any;
  private constantes: any;
  private visibleCE: boolean = false;
  private visibleCA: boolean = false;
  private visibleCG: boolean = false;
  private tablaActiva: string;
  private filteredData: any[] = [];
  private filteredDataTotal: number;
  private mdButtonToggleGroup: MdButtonToggleGroup;

  // Propiedades
  private clickable: boolean = true;
  private selectable: boolean = false;
  private sortable: boolean = true;
  private sortBy: string = 'descripcion';
  private sortOrder: TdDataTableSortingOrder = TdDataTableSortingOrder.Descending;
  private searchTerm: string = '';

  constructor(private _titleService: Title,
    private _loadingService: TdLoadingService,
    private _dialogService: TdDialogService,
    private _constantesService: ConstantesService,
    private _loginService: LoginService,
    private _ngZone: NgZone,
    private _changeDetectorRef: ChangeDetectorRef,
    private _dataTableService: TdDataTableService,
    public media: TdMediaService, private _router: Router, private _route: ActivatedRoute) { }

  ngAfterViewInit(): void {
    this.media.broadcast();
    this._titleService.setTitle('Constantes');
    this.idPaciente = this._loginService.consulta.numeroExpediente;
    this._loadingService.register('constantes.load');
    this.constantesCE = ['TAS', 'TAD', 'FC', 'G.BASAL', 'G.ALEATORIA', 'PESO', 'TALLA', 'IMC', 'P.ABDOMINAL', 'SO2', 'Tª', 'RCV'];
    this.constantesCA = ['HbA1C', 'COLESTEROL', 'HDL-Colesterol', 'LDL-Colesterol', 'TRIGLICERIDOS', 'INR', 'O´SULLIVAN', 'SGO'];
    this.constantesCG = ['G.POSTPRANDIAL', 'G.POSTPRANDIAL (ALMUERZO)', 'G.POSTPRANDIAL (CENA)', 'G.PREPRANDIAL (ALMUERZO)', 'G.PREPRANDIAL (CENA)'];
    this._constantesService.obtenerConstantesPacienteByNumExpediente(this.idPaciente).subscribe((res: any) => {
      this.constantesCE = res.respuesta.constantesCE || [];
      this.constantesCA = res.respuesta.constantesCA || [];
      this.constantesCG = res.respuesta.constantesCG || [];
      this.tablaActiva = 'CE';
      this.valores(this.tablaActiva);
      this.filteredDataTotal = this.filteredData.length;
      this._loadingService.resolve('constantes.load');
    }, (error: Error) => {
      this._loginService.mostrarMensaje('Error cargando constantes.', 'OK', 6000);
      this._loadingService.resolve('constantes.load');
    });
    /*this._constantesService.obtenerConstantesPaciente(
      this.idPaciente, this._loginService.consulta.sexo, this._loginService.consulta.fechaNacimiento).subscribe((res: any) => {
      this.constantes = res.respuesta.constantes || [];
    });*/
    this._changeDetectorRef.detectChanges();
  }

  openDetail(constante: any): void {
     let dialogRef: any  = this._dialogService.open(ConstantesDetalleComponent, {
       data: constante,
       width: '75%',
       height: '500px',
       role: 'dialog',
     });
     dialogRef.componentInstance.constante = constante;
   }

   openDetalleAlta(): void {
     this._router.navigate(['/main/consulta/', this._loginService.consulta.numeroExpediente, 'constantes', 'alta']);
   }

  sort(sortEvent: ITdDataTableSortChangeEvent): void {
    let newData: any[] = [];
    let valores: any[] = [];

    this.sortBy = sortEvent.name;
    this.sortOrder = sortEvent.order;
    this.filter(newData, valores);
  }

  filter(newData: any[], valores: any[]): void {
    if (this.visibleCA) {
      for (let i: any = 0; i < this.constantesCA.length; i++) {
        valores.push(this.constantesCA[i]);
      }
    }
    if (this.visibleCE) {
      for (let i: any = 0; i < this.constantesCE.length; i++) {
        valores.push(this.constantesCE[i]);
      }
    }
    if (this.visibleCG) {
      for (let i: any = 0; i < this.constantesCG.length; i++) {
        valores.push(this.constantesCG[i]);
      }
    }
    newData = valores;
    newData = this._dataTableService.filterData(newData, this.searchTerm, true);

    this.filteredDataTotal = newData.length;
    this.sortOrder = TdDataTableSortingOrder.Ascending;

    newData = this._dataTableService.sortData(newData, this.sortBy, this.sortOrder);
    this.filteredData = newData;
  }

  valores(tipoCons: string): void {
    let newData: any[] = [];
    let valores: any[] = [];

    switch (tipoCons) {
      case 'CA':
        if (this.visibleCA === false) {
          this.visibleCA = true;
        } else {
          this.visibleCA = false;
        }
        break;
      case 'CE':
        if (this.visibleCE === false) {
          this.visibleCE = true;
        } else {
          this.visibleCE = false;
        }
        break;
      case 'CG':
      if (this.visibleCG === false) {
        this.visibleCG = true;
      } else {
        this.visibleCG = false;
      }
      break;
      default:
    }
    this.filter(newData, valores);
  }

  cambiar(tipo: string ): void {
    this.valores(tipo);
  }
}



// WEBPACK FOOTER //
// ./src/app/consulta/constantes/constantes.component.ts